import './style/home.scss';

import React from 'react';
import {CoreItems} from '../../../util/siteData';
import EditableHeader from '../../editor/editableHeader';
import EditablePar from '../../editor/editablePar';
import DrawnLogo from '../../misc/drawnLogo';
import {getImg} from "../../../util/utils";
import EditableButton from "../../editor/editableButton";
import {useNavigate} from 'react-router';
import {CONTACT_ROUTE} from "../../../util/constants";

export default function Home() {
    const navigate = useNavigate();

    function onClickContact() {
        navigate(CONTACT_ROUTE);
    }

    function renderCore() {
        return (
            <div className='core-container'>
                {CoreItems.map(renderCoreItem)}
            </div>
        );
    }

    function renderCoreItem(textKey: string, index: number) {
        return (
            <div key={index} className='core-item'>
                <EditableHeader textKey={`${textKey}-head`} headerType='h2' className='core-title'/>
                <EditablePar textKey={`${textKey}-text`} className='core-content'/>
            </div>
        );
    }

    return (
        <div className='default-page home'>
            <img src={getImg('word-cloud')[0][0]} alt='Welkom' className='word-cloud'/>
            <div className='header-with-image centered'>
                <DrawnLogo/> <EditableHeader textKey='home-header-2' className='page-title'/>
            </div>
            <EditablePar textKey='home-text-2' className='page-par centered'/>
            <EditableButton textKey='home-contact-button' onClick={onClickContact} className='btn-contact centered'/>
            {renderCore()}
        </div>
    );
}

Home.displayName = 'Home';